import React from 'react';
import MUIIconButton, {
  IconButtonProps as MUIIconButtonProperties,
} from '@mui/material/IconButton';

type IconButtonProperties = MUIIconButtonProperties & {
  /** Alias for `aria-label` */
  ariaLabel?: string;
};

const IconButton = ({
  ariaLabel, color, size, ...properties
}: IconButtonProperties) => (
  <MUIIconButton
    aria-label={ariaLabel ?? 'icon'}
    color={color ?? 'primary'}
    size={size ?? 'small'}
    {...properties}
  />
);

export default IconButton;
